import HomeIcon from "@/assets/icons/patients-icon.svg?react";
import NeedActionIcon from "@/assets/icons/alert-circle-icon.svg?react";
import AppointmentIcon from "@/assets/icons/appointment-icon.svg?react";
import MembersIcon from "@/assets/icons/members-icon.svg?react";
import TeamsIcon from "@/assets/icons/teams-icon.svg?react";
import type { ReactNode } from "react";
import type { TFunction } from "i18next";

interface NavigationItem {
  text: string;
  mobileText?: string;
  icon: ReactNode;
  path: string;
}

export const getNavigationItems = (t: TFunction): NavigationItem[] => [
  { text: t("nav.patients"), icon: <HomeIcon />, path: "/patients" },
  { text: t("nav.appointments"), icon: <AppointmentIcon />, path: "/appointments" },
  { text: t("nav.needsAction"), icon: <NeedActionIcon />, path: "/needs-action" },
  {
    text: t("nav.membersGroups"),
    mobileText: t("nav.membersGroupsShort"),
    icon: <MembersIcon />,
    path: "/members-groups",
  },
  {
    text: t("nav.rolesPermissions"),
    mobileText: t("nav.rolesPermissionsShort"),
    icon: <TeamsIcon />,
    path: "/roles-permissions",
  },
];
